import React from 'react'
import Subject from './Subject'
import csm from '../assets/CSE403mid21.pdf'
import cse from '../assets/CSE403end21.pdf'
export default function Dbms() {
  return (
    <div>
       <Subject title="Database Mangement System(CSE403)" sub="DBMS" syllabus="#" mid="Q. Paper"
    book1="“Database System Concepts”, 6th Edition by Abraham Silberschatz, Henry F. Korth,
    S. Sudarshan, McGraw-Hill."
    book1Link="https://www.octawian.ro/fisiere/situri/asor/build/html/_downloads/1fcab53a6d916e39c715fc20a9a9c2a8/Silberschatz_A_databases_6th_ed.pdf" 
    int21="#" mid21={csm} end21={cse}
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}
